module.exports = __webpack_public_path__ + "57ac100c0dea015e7068885d2bb1730a.png";